<template>
  <div id="addEditState">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/countries" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field label="Country Name" v-model.trim="newCountry.name" @blur="checkDuplicates('name')" :rules="[rules.required]" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field label="Country Code" v-model.trim="newCountry.code" @blur="checkDuplicates('code')" :rules="[rules.required, rules.onlyTwoLetters]" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" to="/countries" @click="selectedData = false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store */
import { create, getCollection } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';

// To add new countries by the admin
export default {
  name: 'AddCountry',
  data: () => ({
    newCountry: {
      name: '',
      code: ''
    },
    loading: false,
    selectedData: false,
    rules: {
      required: value => !!value.trim() || 'Field is required.',
      onlyTwoLetters: value => (value.trim().length === 2 && /^[a-zA-Z]+$/.test(value.trim())) || 'Country code must have two letters.'
    },
  }),
  computed: {
    ...mapGetters(['Country'])
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initialize();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    // @vuese
    // Used to fetch the country list if not already exists
    async initialize () {
      if (!this.Country.length) {
        let entity = 'Country';
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setCountry', data);
          }
        }
      }
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide form buttons
    hideButtons () {
      this.selectedData = false;
    },
    // @vuese
    // Used to save the country.
    async save () {
      if (this.$refs.formAdd.validate()) {
        this.hideButtons();
        let { error, data, status } = await create('Country', this.newCountry);
        if (error) {
          console.log('error', error);
          this.changedData();
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          this.loading = false;
          this.Country.push(data);
          swal.fire({
            type: 'success',
            title: 'Country added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/countries' });
            }
          });
        }
      }
    },
    // @vuese
    // Used to check for the country duplication
    // @arg The newly entered country
    checkDuplicates (key) {
      let duplicateValue;
      if (this.newCountry[key]) {
        duplicateValue = this.Country.find(country => country[key].toLowerCase() === this.newCountry[key].toLowerCase());
      }
      if (duplicateValue) {
        let value = key === 'name' ? 'Country name' : 'Country code';
        swal.fire({
          type: 'error',
          title: `${value} is already available`,
          text: `Duplicate ${value}`,
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        this.newCountry[key] = '';
        return;
      }
    },
    // @vuese
    // Used to go back to the country listing page
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/countries' });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Country/add.vue